import api from './api';
import { CSVImport } from '../types';

export interface CSVImportFilters {
  import_type?: 'leads' | 'tenders' | 'customers';
  date_from?: string;
  date_to?: string;
}

export interface CSVImportResult {
  message: string;
  import_id: number;
  total_rows: number;
  successful_rows: number;
  failed_rows: number;
  errors: string[];
  /** Present when import type is customers */
  customers_created?: number;
  customers_updated?: number;
  locations_created?: number;
  locations_updated?: number;
}

export const csvImportService = {
  getAll: async (filters?: CSVImportFilters): Promise<CSVImport[]> => {
    const response = await api.get('/api/csv-imports', { params: filters });
    return response.data;
  },

  getById: async (id: number): Promise<CSVImport> => {
    const response = await api.get(`/api/csv-imports/${id}`);
    return response.data;
  },

  import: async (
    file: File,
    importType: 'leads' | 'tenders' | 'customers',
    updateExisting?: boolean
  ): Promise<CSVImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('import_type', importType);
    if (importType === 'customers' || importType === 'leads' || importType === 'tenders') {
      formData.append('update_existing', updateExisting !== false ? '1' : '0');
    }

    const response = await api.post('/api/csv-imports/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  downloadTemplate: async (type: 'leads' | 'tenders' | 'customers'): Promise<void> => {
    const response = await api.get(`/api/csv-imports/template/${type}`, {
      responseType: 'blob',
    });
    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${type}_template.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};




